import { z } from 'zod';

export const errorSchema = z.object({
  detail: z.string().optional(),
  errorCode: z.number().optional(),
  message: z.string().optional(),
});
